export default (theme) => ({
  card: {
    height: 295
  },
  image: {
    height: 165,
  },
  title: {
    fontSize: '18px'
  },
  titleContainer: {
    padding: 10
  },
  name: {
    fontSize: '18px',
    fontWeight: 500,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  cardContent: {
    padding: ['10px 10px 15px', '!important'],
    position: 'relative'
  },
  subtitle: {
    fontSize: '12px',
    color: '#646262',
    marginTop: 5,
    lineHeight: '12px'
  },
  titleSkeleton: {
    marginLeft: 10,
    marginTop: 10,
    marginBottom: 10
  },
  imageSkeleton: {
    marginBottom: 10
  },
  textSkeleton: {
    padding: 10
  },
  actionArea: {
    height: '100%'
  },
  noNextMeeting: {
    height: 225,
    lineHeight: '225px',
    textAlign: 'center',
    fontSize: '16px'
  },
});
